export default abstract class AxiosService {

	private readonly baseUrl!: string;

	public constructor() {
		this.baseUrl = this.defineBaseUrl().trim();
		if (!this.baseUrl.startsWith('/')) {
			this.baseUrl = '/' + this.baseUrl;
		}
	}

	/**
	 * Method will create an url by prefixing the base url to the path specified. Leading slash
	 * is optional, since it will be added automatically.
	 * @param path the optional url path after the base url (leading slash will be added automatically)
	 * @param baseUrl optional base url override for cross service calls (defaults to defined base url of this service)
	 * @protected
	 */
	public url(path: string | null = null, baseUrl: string = this.baseUrl): string {
		if (path !== null && !path.startsWith('/')) {
			path = '/' + path;
		}

		return `${baseUrl}${path === null ? '' : path}`;
	}

	/**
	 * Defines the base url of the service class. Leading slash is optional, since it will be added
	 * automatically.
	 * @protected
	 */
	protected abstract defineBaseUrl(): string;

}
